import React, { useEffect, useState } from "react";
import { Checkbox, Form, Input } from "antd";
import { Link, useNavigate } from "react-router-dom";
import LoadableButton from "../../components/button/LoadableButton";
import { CheckLoginUrlApi, LoginApi } from "../../api/request/auth";
import toast from "react-hot-toast";
import { setCookies } from "../../services/Cookies";
import GoogleLoginComponent from "./components/GoogleLoginComponent";
import siteConfig from "../../config";
import RightArrow from "../../assets/RightArrow";
// import FacebookLoginComponent from './components/FacebookLoginComponent';

const Login = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (values) => {
    const params = {
      ...values,
      login_type: "api",
      user_type: "client",
    };
    try {
      setIsLoading(true);
      const { data } = await LoginApi(params);
      if (data?.status) {
        form.resetFields();
        localStorage.setItem("email", values?.email);
        toast.success(data?.message);
        if (data?.is_2fa) {
          navigate("/authentication");
        } else {
          navigate("/otp");
        }
      }
      setIsLoading(false);
    } catch (error) {
      if (error?.response?.data?.message) {
        toast.error(error?.response?.data?.message);
      }
      setIsLoading(false);
    }
  };

  const checkLoginUrl = async () => {
    try {
      const { data } = await CheckLoginUrlApi({
        domain_name: siteConfig?.domainName,
      });
      if (data?.status) {
        setCookies("loginToken", data?.token);
      }
    } catch (error) {}
  };

  useEffect(() => {
    checkLoginUrl();
  }, []);

  return (
    <>
      <div className="lg:w-3/5 md:w-[60%] w-full sm:p-0 p-4">
        <Form
          layout="vertical"
          autoComplete="off"
          form={form}
          onFinish={handleSubmit}
          initialValues={{ email: "", password: "" }}
          className="space-y-7"
        >
          <p className="text-center page-title">
            Login to <span className="text-primary">{siteConfig.name}</span>
          </p>
          <Form.Item
            label={<p className="font-semibold">Email</p>}
            name="email"
            rules={[
              { required: true, message: "Please input your email!" },
              { type: "email", message: "Please input valid email!" },
            ]}
          >
            <Input placeholder="Email address" size="large" />
          </Form.Item>
          <Form.Item
            label={
              <div className="flex">
                <p className="font-semibold">Password</p>
              </div>
            }
            name="password"
            rules={[{ required: true, message: "Please input your password!" }]}
          >
            <Input.Password
              placeholder="Password"
              size="large"
              className="col-span-2"
            />
          </Form.Item>
          <div
            style={{ marginTop: "4px" }}
            className="text-primary cursor-pointer text-right"
          >
            <Link to="/forget_password">Forgot Password</Link>
          </div>

          <LoadableButton
            type="submit"
            isLoading={isLoading}
            lable="Login"
            loadingLable="Verifying..."
            className={"w-full"}
          >
            Login <RightArrow />
          </LoadableButton>

          <div className="flex items-center mb-5">
            <hr className="flex-grow" />
            <span className="mx-2 text-Gray">OR LOGIN WITH</span>
            <hr className="flex-grow" />
          </div>
          <div className="flex justify-center items-center lg:px-5 lg:space-y-0 space-y-2 rounded-lg">
            <GoogleLoginComponent />
            {/* <button type="button" className='border rounded-lg flex items-center justify-center py-2 w-full'>
                            <img src='assets/icons/facebook.svg' alt='icon' className='me-1' />
                            Sign in with Facebook
                        </button> */}
            {/* <FacebookLoginComponent/> */}
          </div>
          <p className="text-center  mt-5">
            Not registered yet?{" "}
            <Link to="/register" className="text-primary cursor-pointer">
              Create an account
            </Link>
          </p>
        </Form>
      </div>
    </>
  );
};

export default Login;
